module.exports = __webpack_public_path__ + "static/media/photobooth.26e8f4c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sponsorships/photobooth.jpg
// module id = 564
// module chunks = 6